export const PaymentStatus = {
  success: 'success',
  cancelled: 'cancelled',
  failed: 'failed',
  isRedirect: 'isRedirect',
};

export default PaymentStatus;
